/**
 * Scheduling enums (time off, wages) - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Time off type labels
export const timeOffTypeLabels = {
    annual_leave: 'Annual Leave',
    sick_leave: 'Sick Leave',
    training: 'Training',
    other: 'Other',
};
export const timeOffTypeValues = Object.keys(timeOffTypeLabels);
// Employment type labels (practitioner work details)
export const employmentTypeLabels = {
    full_time: 'Full-time',
    part_time: 'Part-time',
    contractor: 'Contractor',
    self_employed: 'Self-employed',
    intern: 'Intern',
};
export const employmentTypeValues = Object.keys(employmentTypeLabels);
// Wage compensation type labels
export const wageCompensationTypeLabels = {
    none: 'No Compensation',
    hourly: 'Hourly Rate',
};
export const wageCompensationTypeValues = Object.keys(wageCompensationTypeLabels);
// Wage regular-hours-per labels
export const wageRegularHoursPerLabels = {
    day: 'Per Day',
    week: 'Per Week',
};
export const wageRegularHoursPerValues = Object.keys(wageRegularHoursPerLabels);
// Wage overtime type labels
export const wageOvertimeTypeLabels = {
    multiplier: 'Overtime Multiplier',
    hourly_rate: 'Overtime Hourly Rate',
};
export const wageOvertimeTypeValues = Object.keys(wageOvertimeTypeLabels);
// Wage automation setting labels
export const wageAutomationSettingLabels = {
    workspace_default: 'Workspace Default',
    enabled: 'Enabled',
    disabled: 'Disabled',
};
export const wageAutomationSettingValues = Object.keys(wageAutomationSettingLabels);
//# sourceMappingURL=scheduling.js.map